import '../css/module_bookserie.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import { manageLogin } from './module_auth_helper';
import {attachTryPremiumSubscribe, funnelUpdateWhenAvailable} from './module_common';

import {configPlayerCard} from './module_player-card';

import {defaultCarouselSetupNew} from './module_swiper';
import { initCardLazyLoad } from './module_lazyload';
import {configBookCard} from './module_book_card';

import './module_common_actions';

import {
    attachCtaActions,
} from './module_actions';

import {handleCardPlayer} from './module_player-card';
window.handleCardPlayer = handleCardPlayer

import { initNavbar } from './module_header';

const serieCarouselSetUp = function(){
    const out = "bookserie-out"
    const container = "bookserie-swiper-container"
    defaultCarouselSetupNew(container, out, 'auto', 4, 4, 4, searchCardsEndPoint)
}

$(function () {
    initFirebaseApp()
    manageLogin()

    attachTryPremiumSubscribe()
    
    doLast()
    initCardLazyLoad()
    configBookCard()
    
    initNavbar()
    serieCarouselSetUp()

    attachCtaActions()
    
    if (!isPageReloadedAfterLogin) funnelUpdateWhenAvailable('series_viewed');

    configPlayerCard()

});